import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const { isRehydrated } = useAuth();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  if (!isRehydrated) {
    return (
      <div
        className={`fixed inset-0 flex items-center justify-center transition-colors duration-500 ${
          isDark ? 'bg-[#0F0F10]' : 'bg-white'
        }`}
      >
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-neutral-900 flex items-center justify-center">
            <i className="ri-sparkling-line text-white text-lg" />
          </div>
          <div className="w-5 h-5 border-2 border-neutral-300 border-t-neutral-700 rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
